import CustomCheckBox from './CustomCheckBox';

export default CustomCheckBox;
